// Modules
import React from 'react';
// @ts-ignore
import { LocalizationContext } from "react-localize";

// Styles
import "./AdditionalGuestProfile.sass";
import ToolTip from 'Generic/ToolTip';
import { Tip } from 'Interfaces/TipInterface';
import MvIcon from 'Generic/MvIcon';
import MvError from 'Generic/MvError/MvError';
import { MvTextOrEdit } from 'Generic/MvTextOrEdit';
import { read } from 'fs';

// Utils

export interface GuestDetail {
  [key: string]: any;
  firstName: string;
  lastName: string;
  errors: {
    firstName: boolean;
    lastName: boolean;
  }
}

export interface GuestEmail {
  email: string;
  isError: boolean;
}

interface Props {
  additionalGuests: GuestDetail[];
  emails: GuestEmail[];
  maximumGuestCount?: number;
  onAdditionalGuestsChange?: (additionalGuests: GuestDetail[]) => void;
  onEmailsChange?: (emails: GuestEmail[]) => void;
  onEmailBlur?: (i: number, e: React.FocusEvent<HTMLInputElement>, email: GuestEmail) => void;
  onAdditionalGuestInputBlur?: () => boolean;
  readonly?: boolean;
  showAdditionalGuests?: boolean;
  showEmails?: boolean;
}


type State = {
};

class AdditionalGuestProfile extends React.Component<Props, State> {
  addGuestTip: [Tip] = [
    {
      label: "",
      desc: "static.content.sr-tip-add-guest"
    }
  ];
  constructor(props: Props) {
    super(props);
    const { additionalGuests = [] as GuestDetail[], emails = [], maximumGuestCount } = this.props;
  }

  addMoreGuest = () => {
    const { maximumGuestCount = 0, additionalGuests: existingGuests } = this.props;
    const newGuest: GuestDetail = { firstName: '', lastName: '', errors: { firstName: false, lastName: false } };
    
    if (existingGuests && existingGuests.length < maximumGuestCount) {
      const updatedGuests = [...existingGuests, newGuest];
      this.handleGuestState(updatedGuests);
    }
  }

  addMoreEmail = () => {
    const { emails: existingEmails } = this.props;
    const updatedEmails = [...existingEmails, { email: '', isError: false }];
    this.handleEmailState(updatedEmails);
  }

  onGuestInputChange = (val: string, index: number, fieldName: string) => {
    const guests = [...this.props.additionalGuests];
    guests.map((guest, i) => {
      if (i === index) {
        guest[fieldName] = val;
      }
    });

    this.handleGuestState(guests);
  }

  onEmailInputChange = (val: string, index: number) => {
    const { emails: existingEmails } = this.props;
    const updatedEmails = [...existingEmails.map((email, i) => (i === index ? { ...email, email: val } : email))];
    this.handleEmailState(updatedEmails);
  }

  removeGuest = (index: number) => {
    const { additionalGuests: existingGuests } = this.props;
    const updatedGuests = [...existingGuests.filter((guest, i) => i !== index)];
    this.handleGuestState(updatedGuests);
  }

  removeEmail = (index: number) => {
    const { emails: existingEmails } = this.props;
    const updatedEmails = [...existingEmails.filter((email, i) => i !== index)];
    this.handleEmailState(updatedEmails);
  }

  handleGuestState = (additionalGuests: GuestDetail[]) => {
    const { readonly, onAdditionalGuestsChange } = this.props;
    if (!readonly && onAdditionalGuestsChange) {
      onAdditionalGuestsChange(additionalGuests);
    }
  }

  handleEmailState = (emails: GuestEmail[]) => {
    const { readonly, onEmailsChange } = this.props;
    if (!readonly && onEmailsChange) {
      onEmailsChange(emails);
    }
  }

  handleEmailBlur = (i: number, e: any, email: GuestEmail) => {
    const { readonly, onEmailBlur } = this.props;
    if (!readonly && onEmailBlur) {
      onEmailBlur(i, e, email);
    }
  }

  render() {
    const { localize } = this.context;
    const { maximumGuestCount, additionalGuests = [], emails = [], readonly, showAdditionalGuests = true, showEmails = true } = this.props;
    const isAddGuestDisabled = additionalGuests.length === maximumGuestCount;

    return (
      <div className='row additionalGuest'>
        {showAdditionalGuests && <div className="fifty column guestDetails">
          <div className="single-input">
            <h2>{localize("static.content.sr-additional-guests")}</h2>
            {additionalGuests.map((detail, i) => {
              return (<div key={`quest_${i}`}>
                <table>
                  <tr>
                    <td className='firstName'>
                    <MvTextOrEdit
                        onChange={(val) => this.onGuestInputChange(val, i, 'firstName')}
                        onBlur={(e) => {}}
                        // onBlur={(e) => this.props.onAdditionalGuestInputBlur()}
                        value={readonly ?  `${detail.firstName} ${detail.lastName}` : detail.firstName}
                        placeholder={localize("static.content.sr-placeholder-firstname")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={!readonly}
                        hideLabel={true}
                        label=''
                        id={`add_guest_first_name_${i}`}
                        name={`email_${i}`}
                        hasError={detail.errors && detail.errors.firstName}
                        errorMessage={'First Name is Required'}
                        isRequired={false}
                        inputComponent='text'
                      />
                    </td>
                    {!readonly && <td>
                      <MvTextOrEdit
                        onChange={(val) => this.onGuestInputChange(val, i, 'lastName')}
                        // onBlur={(e) => this.props.onAdditionalGuestInputBlur()}
                        onBlur={(e) => {}}
                        value={detail.lastName}
                        placeholder={localize("static.content.sr-placeholder-lastname")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={!readonly}
                        hideLabel={true}
                        label=''
                        id={`add_guest_last_name_${i}`}
                        name={`email_${i}`}
                        hasError={detail.errors && detail.errors.lastName}
                        errorMessage={'Last Name is Required'}
                        isRequired={false}
                        inputComponent='text'
                      />
                    </td>}
                    {!readonly && <td>
                      <span className='removeItem' onClick={() => this.removeGuest(i)} >
                        <MvIcon
                          color="#009687"
                          height="14px"
                          width="14px"
                          icon="x"
                        />
                      </span>
                    </td>}
                  </tr>
                </table>
              </div>);
            })}
            {readonly && additionalGuests.length === 0 && <p>No additional guests added</p>}
            {!readonly && <p>
              <span className={`addItem ${isAddGuestDisabled ? 'disabled' : ''}`} onClick={() => !isAddGuestDisabled && this.addMoreGuest()}>+ {localize("static.content.sr-add-guest")}</span>
              <span>
                <ToolTip
                  id='additional-guests-add'
                  tabIndex={0}
                  tip={this.addGuestTip}
                  useRefToPosition={false}
                >
                  <span className="question-icon">{"?"}</span>
                </ToolTip>
              </span>
            </p>}
          </div>
        </div>}
        {showEmails && <div className="fifty column emails">
          <div className="single-input">
            <h2>{localize("static.content.sr-additional-emails")}</h2>
            {emails.map((email, i) => {
              return (<div key={`email_${i}`}>
                <table>
                  <tr>
                    <td>
                      <MvTextOrEdit
                        onChange={(val) => this.onEmailInputChange(val, i)}
                        onBlur={(e) => this.handleEmailBlur(i, e, email)}
                        value={email.email}
                        placeholder={localize("static.content.sr-placeholder-email")}
                        globalTxData={'GlobalLinkNoTx'}
                        isEditing={!readonly}
                        hideLabel={true}
                        label=''
                        id={`email_${i}`}
                        name={`email_${i}`}
                        hasError={email.isError}
                        errorMessage={localize("static.content.sr-error-email")}
                        isRequired={false}
                        inputComponent='text'
                      />
                    </td>
                    {!readonly && <td>
                      <span className={`removeItem ${email.isError ? 'removeItemWithError' : ''}`} onClick={() => this.removeEmail(i)} >
                        <MvIcon
                          color="#009687"
                          height="14px"
                          width="14px"
                          icon="x"
                        />
                      </span>
                    </td>}
                  </tr>
                </table>
              </div>);
            })}
            {readonly && emails.length === 0 && <p>No emails added</p>}
            {!readonly && <p><span className='addItem' onClick={this.addMoreEmail}>+ {localize("static.content.sradd-email")}</span></p>}
          </div>
        </div>}
      </div>
    );
  }
}

AdditionalGuestProfile.contextType = LocalizationContext;

export default AdditionalGuestProfile;
